import React, { useContext } from 'react';
import EkovillaContext from '../contexts/EkovillaContext';
import EkovillaMeter from './EkovillaMeter';

import { Table, Tbody, Thead, Tr, Td, Th } from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';

function CompetitorTotal() {

    const { competitor } = useContext(EkovillaContext);

    let cubic = 0;
    let thickness = 0;
    let carbonFoot = 0;
    let carbonHand = 0;

    let carbonFootTotal = 0;
    let carbonHandTotal = 0;

    let totalWeight = 0;

    const countCarbonKg = (cubic, thickness, carbon) => {
        const total = cubic * thickness * carbon;
        return total;
    }

    const countTotalWeight = (cubic, thickness) => {
        const totalWeight = cubic * thickness;
        return totalWeight;
    }

    Object.values(competitor).forEach(value => {
        cubic = value.comInsulationCubic;
        thickness = value.comInsulationThicknessCubic;
        carbonFoot = value.comCarbonFoot;
        carbonHand = value.comCarbonHand;

        carbonFootTotal += countCarbonKg(cubic, thickness, carbonFoot);
        carbonHandTotal += countCarbonKg(cubic, thickness, carbonHand);
        totalWeight += countTotalWeight(cubic, thickness);
    })

    return (

        <Table className="table-auto w-full">
            <Thead>
                <Tr>
                    <Th className="invisible"></Th>
                    <Th className="whitespace-no-wrap text-sm xl:text-base">Hiilijalanjälki kg CO<sub>2</sub>e</Th>
                    <Th className="whitespace-no-wrap text-sm xl:text-base">Hiilikädenjälki kg CO<sub>2</sub>e</Th>
                </Tr>
            </Thead>
            <Tbody>
                <Tr className="border-collapse border border-gray-600">
                    <Td className="text-left text-sm xl:text-base pl-1 w-full xl:w-1/3">Vaihtoehtoinen eriste yhteensä</Td>
                    <Td className="text-center text-sm xl:text-base border-collapse border border-gray-600">{carbonFootTotal.toFixed(1)}</Td>
                    <Td className="text-center text-sm xl:text-base border-collapse border border-gray-600">{carbonHandTotal.toFixed(1)}</Td>
                </Tr>
                <Tr>
                    <Td className="hidden sm:table-cell"></Td>
                    <Td className="meter border-collapse border border-gray-600 text-sm xl:text-sm">
                        <EkovillaMeter
                            value={carbonFootTotal > totalWeight ? totalWeight : carbonFootTotal}
                            maxValue={totalWeight}
                            startColor="#FFFF00"
                            endColor="#FF0000"
                            showValue={false}
                        />
                    </Td>
                    <Td className="meter border-collapse border border-gray-600 text-sm xl:text-base">
                        <EkovillaMeter
                            value={carbonHandTotal > totalWeight * 2 ? totalWeight * 2 : carbonHandTotal}
                            maxValue={totalWeight * 2}
                            startColor="#FFFF00"
                            endColor="#004d00"
                            showValue={false}
                        />
                    </Td>
                </Tr>
            </Tbody>
        </Table>
    )
}

export default CompetitorTotal;